function buf2hex(buffer) { // buffer is an ArrayBuffer
    return [...new Uint8Array(buffer)]
        .map(x => x.toString(16).padStart(2, '0'))
        .join('');
}
const hex2buf = hexString =>
    new Uint8Array(hexString.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));

function reverseBitsInBytes(array) {
    if (!(array instanceof Uint8Array)) {
        throw new Error("Input must be a Uint8Array");
    }

    const reverseByte = byte => {
        let reversed = 0;
        for (let i = 0; i < 8; i++) {
            if (byte & (1 << i)) {
                reversed |= (1 << (7 - i));
            }
        }
        return reversed;
    };

    const reversedArray = new Uint8Array(array.length);
    for (let i = 0; i < array.length; i++) {
        reversedArray[i] = reverseByte(array[i]);
    }
    return reversedArray;
}

function concatTypedArrays(a, b) { // a, b TypedArray of same type
    var c = new (a.constructor)(a.length + b.length);
    c.set(a, 0);
    c.set(b, a.length);
    return c;
}

function formatMemorySize(bits) {
    if (bits < 8e6) { // Less than 1 MB (or 8 Mbit)
        const kilobits = bits / 1024;
        const kilobytes = bits / 1024 / 8;
        return `${kilobytes}KB/${kilobits}Kbit`;
    } else {
        const megabits = bits / (1024 * 1024);
        const megabytes = bits / (1024 * 1024 * 8);
        return `${megabytes}MB/${megabits}Mbit`;
    }
}
function downloadUint8ArrayAsBin(filename, uint8Array) {
    // Create a Blob from the Uint8Array
    const blob = new Blob([uint8Array], { type: "application/octet-stream" });

    // Create a link element
    const link = document.createElement("a");

    // Create an object URL for the Blob and set it as the href attribute
    link.href = URL.createObjectURL(blob);
    link.download = filename; // Set the file name for the download

    // Append the link to the body (required for Firefox)
    document.body.appendChild(link);

    // Programmatically click the link to trigger the download
    link.click();

    // Clean up by revoking the object URL and removing the link element
    URL.revokeObjectURL(link.href);
    document.body.removeChild(link);
}

function buildFileSelector() {
    const fileSelector = document.createElement('input');
    fileSelector.setAttribute('type', 'file');
    fileSelector.setAttribute('multiple', 'multiple');
    return fileSelector;
}

function createUint24(value) {
    var data = new Uint8Array(4);
    var data_view = new DataView(data.buffer);
    data_view.setUint32(0, value, 1);
    return data.subarray(0, 3);
}

function createUint32(value) {
    var data = new Uint8Array(4);
    var data_view = new DataView(data.buffer);
    data_view.setUint32(0, value, 1);
    return data;
}

export { buf2hex, hex2buf, reverseBitsInBytes, concatTypedArrays, downloadUint8ArrayAsBin, buildFileSelector, formatMemorySize, createUint24, createUint32 }
